import { render, staticRenderFns } from "./SupplierModal.vue?vue&type=template&id=213c5daa&scoped=true&"
import script from "./SupplierModal.vue?vue&type=script&lang=js&"
export * from "./SupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierModal.vue?vue&type=style&index=0&id=213c5daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c5daa",
  null
  
)

export default component.exports